import { hFetch } from '@/lib/hfetch';
import type { ContactEntity } from './entity_types/Contact';
import type { ContactEventEntity } from './entity_types/ContactEvent';
import { hFetch as deprecatedHFetch } from './hFetch';

export type GetContactEventResponse = ContactEventEntity & ContactEntity;
export const getContactEvents = (contactId: string) => {
  return deprecatedHFetch<GetContactEventResponse[]>({ url: `/api/contact_events?contact_id=${contactId}` });
};

export const deleteContactEvent = (contactEventId: number) => {
  return hFetch({ url: `/api/contact_events/${contactEventId}`, method: 'DELETE' });
};
